import React from 'react'
import {Flex, Text, Container} from '@chakra-ui/react'

import {ThemeProvider} from '../../components'
import PoweredBy from '../../components/PoweredBy'

const InvalidToken = () => {
  return (
    <ThemeProvider>
      <Container
        maxWidth={{base: 'full', lg: '80ch'}}
        py={{base: 'sm', md: 'lg'}}
      >
        <Flex
          justifyContent="space-between"
          direction={{base: 'column', md: 'row'}}
          alignItems={{base: 'start', md: 'end'}}
          gap="sm"
        >
          <Text textStyle="headline2" order={{base: '2', md: '1'}}>
            Link Expired
          </Text>

          <PoweredBy />
        </Flex>
        <Text textStyle="body-copy" pt="md">
          This link has expired as a new version of the statement is available.
          Check your email for the latest version.
        </Text>
      </Container>
    </ThemeProvider>
  )
}

export default InvalidToken
